import { render, staticRenderFns } from "./shopAttachment.vue?vue&type=template&id=8e583c9a&scoped=true&"
import script from "./shopAttachment.vue?vue&type=script&lang=js&"
export * from "./shopAttachment.vue?vue&type=script&lang=js&"
import style0 from "./shopAttachment.vue?vue&type=style&index=0&id=8e583c9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e583c9a",
  null
  
)

export default component.exports